import { render, staticRenderFns } from "./Detils.vue?vue&type=template&id=551ea2ce&scoped=true"
import script from "./Detils.vue?vue&type=script&lang=js"
export * from "./Detils.vue?vue&type=script&lang=js"
import style0 from "./Detils.vue?vue&type=style&index=0&id=551ea2ce&prod&scoped=scoped&lang=css"
import style1 from "./Detils.vue?vue&type=style&index=1&id=551ea2ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ea2ce",
  null
  
)

export default component.exports